import { FC } from 'react';
import { MediaManager } from 'src/manager/MediaManager';
import { SvgIcon } from '../SvgIcon';
import './styles.scss';

type Props = {
  coin: number;
  type: string;
};

const Coins: FC<Props> = ({ coin, type }) => {
  return (
    <div className={'coins_wrapper'}>
      <SvgIcon src={MediaManager.getSrcFromMediaAssets(`${type === 'FPP' ? 'coin' : 'gos'}.svg`, '/icons/svg/')} />
      {coin?.toFixed()}
    </div>
  );
};
export default Coins;
